module.exports = __webpack_public_path__ + "static/media/lafise-headset.2f2e3a44.svg";